var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
export function useKeypad() {
    var _a = useState([]), value = _a[0], setValue = _a[1];
    var handleChange = function (key) {
        if (key === 'ok')
            return;
        if (key === 'Backspace')
            return handleBackspace();
        if (value.length >= 3)
            return shake();
        else
            setValue(function (prev) { return __spreadArray(__spreadArray([], prev, true), [key], false); });
    };
    var handleBackspace = function () {
        if (value.length <= 0)
            return shake();
        setValue(function (prev) { return prev.slice(0, -1); });
    };
    var _b = useState(false), isShaking = _b[0], setIsShaking = _b[1];
    var shake = function () {
        setIsShaking(true);
        setTimeout(function () { return setIsShaking(false); }, 500);
    };
    return { value: value, handleChange: handleChange, handleBackspace: handleBackspace, isShaking: isShaking, shake: shake, setValue: setValue };
}
export default useKeypad;
